// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/common/v1/types.proto (package creativefabrica.common.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/common/v1/types.proto.
 */
export const file_creativefabrica_common_v1_types: GenFile = /*@__PURE__*/
  fileDesc("CiVjcmVhdGl2ZWZhYnJpY2EvY29tbW9uL3YxL3R5cGVzLnByb3RvEhljcmVhdGl2ZWZhYnJpY2EuY29tbW9uLnYxIlIKBFNvcnQSDQoFZmllbGQYASABKAkSOwoJZGlyZWN0aW9uGAIgASgOMiguY3JlYXRpdmVmYWJyaWNhLmNvbW1vbi52MS5Tb3J0RGlyZWN0aW9uIhcKBkN1cnNvchINCgV2YWx1ZRgBIAEoCSKCAQoRUGFnaW5hdGlvblJlcXVlc3QSMAoFYWZ0ZXIYASABKAsyIS5jcmVhdGl2ZWZhYnJpY2EuY29tbW9uLnYxLkN1cnNvchIMCgR0YWtlGAIgASgFEi0KBHNvcnQYAyABKAsyHy5jcmVhdGl2ZWZhYnJpY2EuY29tbW9uLnYxLlNvcnQiVwoSUGFnaW5hdGlvblJlc3BvbnNlEhAKCGhhc19tb3JlGAEgASgIEi8KBG5leHQYAiABKAsyIS5jcmVhdGl2ZWZhYnJpY2EuY29tbW9uLnYxLkN1cnNvcipgCg1Tb3J0RGlyZWN0aW9uEh4KGlNPUlRfRElSRUNUSU9OX1VOU1BFQ0lGSUVEEAASFgoSU09SVF9ESVJFQ1RJT05fQVNDEAESFwoTU09SVF9ESVJFQ1RJT05fREVTQxACQk9aTWdpdGh1Yi5jb20vY3JlYXRpdmVmYWJyaWNhL3NjaGVtYXMvcGtnL2dlbi9jcmVhdGl2ZWZhYnJpY2EvY29tbW9uL3YxO2NvbW1vbnYxYgZwcm90bzM");

/**
 * @generated from message creativefabrica.common.v1.Sort
 */
export type Sort = Message<"creativefabrica.common.v1.Sort"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: creativefabrica.common.v1.SortDirection direction = 2;
   */
  direction: SortDirection;
};

/**
 * @generated from message creativefabrica.common.v1.Sort
 */
export type SortJson = {
  /**
   * @generated from field: string field = 1;
   */
  field?: string;

  /**
   * @generated from field: creativefabrica.common.v1.SortDirection direction = 2;
   */
  direction?: SortDirectionJson;
};

/**
 * Describes the message creativefabrica.common.v1.Sort.
 * Use `create(SortSchema)` to create a new message.
 */
export const SortSchema: GenMessage<Sort, {jsonType: SortJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_types, 0);

/**
 * @generated from message creativefabrica.common.v1.Cursor
 */
export type Cursor = Message<"creativefabrica.common.v1.Cursor"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * @generated from message creativefabrica.common.v1.Cursor
 */
export type CursorJson = {
  /**
   * @generated from field: string value = 1;
   */
  value?: string;
};

/**
 * Describes the message creativefabrica.common.v1.Cursor.
 * Use `create(CursorSchema)` to create a new message.
 */
export const CursorSchema: GenMessage<Cursor, {jsonType: CursorJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_types, 1);

/**
 * @generated from message creativefabrica.common.v1.PaginationRequest
 */
export type PaginationRequest = Message<"creativefabrica.common.v1.PaginationRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.Cursor after = 1;
   */
  after?: Cursor | undefined;

  /**
   * @generated from field: int32 take = 2;
   */
  take: number;

  /**
   * @generated from field: creativefabrica.common.v1.Sort sort = 3;
   */
  sort?: Sort | undefined;
};

/**
 * @generated from message creativefabrica.common.v1.PaginationRequest
 */
export type PaginationRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.Cursor after = 1;
   */
  after?: CursorJson;

  /**
   * @generated from field: int32 take = 2;
   */
  take?: number;

  /**
   * @generated from field: creativefabrica.common.v1.Sort sort = 3;
   */
  sort?: SortJson;
};

/**
 * Describes the message creativefabrica.common.v1.PaginationRequest.
 * Use `create(PaginationRequestSchema)` to create a new message.
 */
export const PaginationRequestSchema: GenMessage<PaginationRequest, {jsonType: PaginationRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_types, 2);

/**
 * @generated from message creativefabrica.common.v1.PaginationResponse
 */
export type PaginationResponse = Message<"creativefabrica.common.v1.PaginationResponse"> & {
  /**
   * @generated from field: bool has_more = 1;
   */
  hasMore: boolean;

  /**
   * @generated from field: creativefabrica.common.v1.Cursor next = 2;
   */
  next?: Cursor | undefined;
};

/**
 * @generated from message creativefabrica.common.v1.PaginationResponse
 */
export type PaginationResponseJson = {
  /**
   * @generated from field: bool has_more = 1;
   */
  hasMore?: boolean;

  /**
   * @generated from field: creativefabrica.common.v1.Cursor next = 2;
   */
  next?: CursorJson;
};

/**
 * Describes the message creativefabrica.common.v1.PaginationResponse.
 * Use `create(PaginationResponseSchema)` to create a new message.
 */
export const PaginationResponseSchema: GenMessage<PaginationResponse, {jsonType: PaginationResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_types, 3);

/**
 * @generated from enum creativefabrica.common.v1.SortDirection
 */
export enum SortDirection {
  /**
   * @generated from enum value: SORT_DIRECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SORT_DIRECTION_ASC = 1;
   */
  ASC = 1,

  /**
   * @generated from enum value: SORT_DIRECTION_DESC = 2;
   */
  DESC = 2,
}

/**
 * @generated from enum creativefabrica.common.v1.SortDirection
 */
export type SortDirectionJson = "SORT_DIRECTION_UNSPECIFIED" | "SORT_DIRECTION_ASC" | "SORT_DIRECTION_DESC";

/**
 * Describes the enum creativefabrica.common.v1.SortDirection.
 */
export const SortDirectionSchema: GenEnum<SortDirection, SortDirectionJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_common_v1_types, 0);

